import './index.styl';
import template from './index.jst';
// import { Model } from 'backbone';
import { View } from 'backbone.marionette';

export default class GameInfoView extends View {
	get template() {
		return template;
	}

	className() {
		return 'user-info-inner';
	}

	/**
	 * Set all UI for this view
	 * @returns object
	 */
	ui() {
		return {
		};
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
		};
	}

	initialize() {
	}
}